export default __webpack_public_path__ + "static/media/width-ratio.9becc9b8.svg";